const PUBLIC = {
  OVERVIEW: {
    PATH: '/lasting-power-of-attorney',
    VIEW: 'Overview',
  },
}

export const ROUTES = { PUBLIC }
